import PaymentMethod, { PaymentMethodProps } from './PaymentMethod';

export type { PaymentMethodProps };
export default PaymentMethod;
